exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-gops.js
// module id = ./node_modules/core-js/library/modules/_object-gops.js
// module chunks = index